// @ts-check
import { useState, useEffect } from 'react'
import useSWR from 'swr'
import { surveyApi } from '~/legacy/fetchApi'

// Fetch fresh bdp data from our backend
const fetchSurvey = async (surveyId, page, isAnonymous) => {
  return surveyApi
    .getSurvey({ surveyId, page, skipAuth: isAnonymous })
    .then(([, response]) => response)
}

// Our bdp data in SWR
export const SWR_SURVEY = 'survey/:survey_id'

// Hook to manage the raw Survey Building in SWR as well as format the raw Survey Building.
export const useSurveySelector = (
  surveyBuildingId = null,
  page = null,
  isAnonymous = false
) => {
  // Async wrapper for fetching our bdp data from backend
  const swrKey = surveyBuildingId ? SWR_SURVEY.replace(':survey_id', surveyBuildingId) : null
  const fetcher = surveyBuildingId ? () => fetchSurvey(surveyBuildingId, page, isAnonymous) : null

  // SWR bdp data
  const { data: rawSurvey, error, mutate } = useSWR(swrKey, fetcher)
  // Whenever we change/update the bdp data via api, format it
  const [survey, setSurvey] = useState(rawSurvey)

  useEffect(() => {
    if (rawSurvey) {
      setSurvey(rawSurvey)
    } else {
      setSurvey(null)
    }
  }, [rawSurvey])

  return {
    survey,
    mutate,
    loading: !survey,
    error,
  }
}
